import React, { useState } from "react";
import { Routes, Route, Navigate, useNavigate } from "react-router-dom";
import AIStrategyQuizContainer from "./AIStrategyQuizContainer";
import AIStrategyResults from "./AIStrategyResults";
import UserInfoForm, { UserInfo } from "../../components/UserInfoForm";

export interface AIStrategyResult {
  questionId: number;
  selectedOption: number;
  scores: {
    roadmapPlanning: number;
    businessAlignment: number;
    implementationReadiness: number;
  };
}

const AIStrategyQuiz: React.FC = () => {
  const navigate = useNavigate();
  const [userInfo, setUserInfo] = useState<UserInfo | null>(null);

  const handleUserInfoSubmit = (userData: UserInfo) => {
    setUserInfo(userData);
    navigate("quiz");
  };

  return (
    <Routes>
      <Route
        index
        element={
          <UserInfoForm
            onSubmit={handleUserInfoSubmit}
            subtitle="Build Your AI Transformation Roadmap"
          />
        }
      />
      <Route
        path="quiz"
        element={<AIStrategyQuizContainer userInfo={userInfo} />}
      />
      <Route path="results" element={<AIStrategyResults />} />
      <Route path="*" element={<Navigate to="/aistrategy" replace />} />
    </Routes>
  );
};

export default AIStrategyQuiz;
